import { StyledAdressFinderWithoutModal } from '../style';
import AddressFinder from '../react-amk.min.js';
import { Form, FormInstance, Input } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import useFormValidation from 'utils/useFormValidation';
import { Validations } from '../../../interfaces';
import { Rule } from 'rc-field-form/lib/interface';
import { FormItemLayout } from 'antd/es/form/Form';

type AMKResponse = {
  index: number;
  data: {
    address: string;
    code: number;
    dzvCode: number;
    dzvName: string;
    ielCode: number;
    ielName: string;
    irAdrese: boolean;
    nltCode: number;
    nltName: string;
    pilCode: number;
    pilName: string;
    typ: number;
    zipCode: string;
    novName: string;
    pagName: string;
    lksLat: number;
    lksLong: number;
  };
};

export interface AddressData {
  address: string;
  lksLat: number | null;
  lksLong: number | null;
}

interface AddressFinderProps extends Validations {
  form: FormInstance;
  name?: string | (string | number)[];
  fullPath?: (string | number)[];
  latName?: string | (string | number)[];
  longName?: string | (string | number)[];
  disabled: boolean;
  deliveryTypeValue?: string;
  rules?: Rule[];
  label?: string | React.ReactNode;
  layout?: FormItemLayout;
  onAddressSelect?: (data: AddressData) => void;
  requireCoordinates?: boolean;
  placeholder?: string;
  className?: string;
}

export const WithoutModalAddressFinder = ({
  form,
  name = 'address',
  fullPath,
  latName = 'lks_lat',
  longName = 'lks_long',
  disabled,
  deliveryTypeValue,
  validations,
  rules = [],
  label,
  layout,
  onAddressSelect,
  requireCoordinates = false,
  placeholder,
  className = 'address-finder-without-modal',
}: AddressFinderProps) => {
  const { formValidations } = useFormValidation();
  const AMK_ADRESS_SEARCH = `${window.runConfig.backendUrl}/api/v2/vraa/adress${requireCoordinates ? '-with-coordinates' : ''}`;

  const addressValue = Form.useWatch(fullPath || name, form);

  if (disabled) {
    return (
      <StyledAdressFinderWithoutModal className={className}>
        <Form.Item name={name} label={label} layout={layout}>
          <Input readOnly disabled />
        </Form.Item>
      </StyledAdressFinderWithoutModal>
    );
  }

  const handleSelectAddress = (event: AMKResponse) => {
    if (event.data?.code) {
      let finalAddress = `${event.data?.address}`;

      if (!!event.data?.zipCode) {
        finalAddress = `${event.data?.address}, ${event.data?.zipCode}`;
      }

      const lat = event.data?.lksLat || null;
      const long = event.data?.lksLong || null;

      form.setFields([
        { name: fullPath || name, value: finalAddress },
        { name: latName, value: lat },
        { name: longName, value: long },
      ]);
      form.validateFields([fullPath || name]);

      onAddressSelect?.({
        address: finalAddress,
        lksLat: lat,
        lksLong: long,
      });
    }
  };

  const handleClear = () => {
    form.setFields([
      { name: fullPath || name, value: null },
      { name: latName, value: null },
      { name: longName, value: null },
    ]);
    onAddressSelect?.({
      address: '',
      lksLat: null,
      lksLong: null,
    });
  };

  return (
    <StyledAdressFinderWithoutModal className={className}>
      <Form.Item
        className={'delivery-drawer-create-address'}
        name={name}
        label={label}
        layout={layout}
        rules={validations ? formValidations(validations) : rules}
      >
        {addressValue ? (
          <Input suffix={<CloseOutlined onClick={handleClear} />} />
        ) : (
          <AddressFinder
            apiBaseEndpointUri={AMK_ADRESS_SEARCH}
            onItemSelect={handleSelectAddress}
            highlightMatches={false}
            defaultOpenAllRows={false}
            visibleColumnLabels={['address', 'selectButton']}
            visibleDataLabels={[]}
            showOnlyLowestLevelAddresses={requireCoordinates ? false : true}
          />
        )}
      </Form.Item>
      <Form.Item name={latName} hidden>
        <Input />
      </Form.Item>
      <Form.Item name={longName} hidden>
        <Input />
      </Form.Item>
    </StyledAdressFinderWithoutModal>
  );
};
